export const TRANSLATION_NAMESPACE = {
  common: 'common',
  auth: 'auth',
  navigation: 'navigation',
  calendar: 'calendar',
  appointments: 'appointments',
  dashboard: 'dashboard',
  settings: 'settings',
  validation: 'validation',
  errors: 'errors',
  admin: 'admin',
  onboarding: 'onboarding',
  modules: 'modules',
  clients: 'clients',
  clientImport: 'clientImport',
  patients: 'patients',
  treatmentLibrary: 'treatmentLibrary',
  services: 'services',
  consultations: 'consultations',
  intake: 'intake',
  plans: 'plans',
  files: 'files',
  filePreview: 'filePreview',
  notifications: 'notifications',
  progress: 'progress',
  reports: 'reports',
  chat: 'chat',
  support: 'support',
  consents: 'consents',
  team: 'team',
  broadcasts: 'broadcasts',
  legal: 'legal',
  activity: 'activity',
  emailLog: 'emailLog',
  customDomains: 'customDomains',
  workspaceData: 'workspaceData',
  assistant: 'assistant',
} as const;

export type TranslationNamespace =
  (typeof TRANSLATION_NAMESPACE)[keyof typeof TRANSLATION_NAMESPACE];

export const TRANSLATION_NAMESPACE_LIST: TranslationNamespace[] = [
  TRANSLATION_NAMESPACE.common,
  TRANSLATION_NAMESPACE.auth,
  TRANSLATION_NAMESPACE.navigation,
  TRANSLATION_NAMESPACE.calendar,
  TRANSLATION_NAMESPACE.appointments,
  TRANSLATION_NAMESPACE.dashboard,
  TRANSLATION_NAMESPACE.settings,
  TRANSLATION_NAMESPACE.validation,
  TRANSLATION_NAMESPACE.errors,
  TRANSLATION_NAMESPACE.admin,
  TRANSLATION_NAMESPACE.onboarding,
  TRANSLATION_NAMESPACE.modules,
  TRANSLATION_NAMESPACE.clients,
  TRANSLATION_NAMESPACE.clientImport,
  TRANSLATION_NAMESPACE.patients,
  TRANSLATION_NAMESPACE.treatmentLibrary,
  TRANSLATION_NAMESPACE.services,
  TRANSLATION_NAMESPACE.consultations,
  TRANSLATION_NAMESPACE.intake,
  TRANSLATION_NAMESPACE.plans,
  TRANSLATION_NAMESPACE.files,
  TRANSLATION_NAMESPACE.filePreview,
  TRANSLATION_NAMESPACE.notifications,
  TRANSLATION_NAMESPACE.progress,
  TRANSLATION_NAMESPACE.reports,
  TRANSLATION_NAMESPACE.chat,
  TRANSLATION_NAMESPACE.support,
  TRANSLATION_NAMESPACE.consents,
  TRANSLATION_NAMESPACE.team,
  TRANSLATION_NAMESPACE.broadcasts,
  TRANSLATION_NAMESPACE.legal,
  TRANSLATION_NAMESPACE.activity,
  TRANSLATION_NAMESPACE.emailLog,
  TRANSLATION_NAMESPACE.customDomains,
  TRANSLATION_NAMESPACE.workspaceData,
  TRANSLATION_NAMESPACE.assistant,
];

export const DEFAULT_TRANSLATION_NAMESPACE: TranslationNamespace = TRANSLATION_NAMESPACE.common;
